import React, { useRef, useState, useEffect } from "react";
import TinyEditor from "../../Components/TextEditor/Editor";
import InputField from "../../Components/InputField/InputField";
import CustomUploadBox from "../../Components/CustomUploadBox/CustomUploadBox";
import Button from "../../Components/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import useMultiUpload from "../../utils/CustomHooks/useMultiUpload";
import Cookies from 'js-cookie'

import {
  createBlog,
  clearBlogSliceStates,
  clearBlogSliceData,
  clearBlogDetailData,
  clearBlogUserData,
  clearBlogSliceMessages,
  createBlogAsDraft,
  dispatchSaveAsDraftButton,
  fetchUserForBlogs
} from "../../redux/blogs/blogSlice";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { TagsInput } from "react-tag-input-component";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./CreateBlog.css";
import CreateBlogMenu from "../../Layouts/Menu/CreateBlogMenu/CreateBlogMenu";
import LogoutPopup from "../../Components/Popups/LogoutPopup/LogoutPopup"
import CustomRadioButton from "../../Components/CustomRadioButton/CustomRadioButton";
import CustomSearchableDropdown from "../../Components/Popups/CustomSearchableDropdown/CustomSearchableDropdown";
import FaqSection from "../../Components/FaqSection/FaqSection";

const CreateBlog = () => {
  const SPECIAL_ORG_ID = "52c3b93c-59ba-44e7-8e99-bd5fc889b68f";
  const {
    isBlogSliceFetching,
    isBlogSliceFetchingSmall,
    isBlogSliceSuccess,
    isBlogCreateSuccess,
    isBlogSliceError,
    isBlogDraftCreateSuccess,
    blogSliceErrorMessage,
    blogSliceSuccessMessage,
    toggleSaveAsDraftPopup,
    blogsUsers
  } = useSelector((state) => state.blog);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isFileUploading,
    fileUploadError,
    fileUploadSuccess,
    uploadedFileData,
    uploadFile,
  } = useMultiUpload();
  const SmallImageRef = React.useRef(null);
  const ThumbnailRef = React.useRef(null);
  const authorImageRef = React.useRef(null)
  const [SmallImageName, setSmallImageName] = useState(null);
  const [authorImage, setAuthorImage] = useState(null)
  const [thumbnailName, setThumbnailName] = useState(null);
  const [uploadingField, setUploadingField] = useState(null);
  const [isArticle, setIsArticle] = useState(false);
  const initialLoginCookie = Cookies.get("loginData");
  const [orgId, setOrgId] = useState(() => {
    if (!initialLoginCookie) return null;
    try {
      return JSON.parse(initialLoginCookie)?.organizationId ?? null;
    } catch {
      return null;
    }
  });
  const shouldShowErrorBorders = orgId != SPECIAL_ORG_ID;

  // UI-only: SEO accordion expanded state
  const [seoOpen, setSeoOpen] = useState(true);

  const [formData, setFormData] = useState(
    {
      blogId: "",
      blog_Title: "",
      blog_Type: "",
      blog_Description: "",
      SmallImage: "",
      thumbnail: "",
      blog_Body: "",
      wordCount: 0,
      readingTime: 0,
      selectedTag: ["Business", "Technology"],
      youtubeUrl: "",
      articleLink: "",
      isArticle: "false",
      membersOnly: "false",
      categories: [],
      author: "",
      authorName: "",
      authorImage: "",
      altImg: "",
      metaTitle: "",
      faqs: [],
      // Non-SPECIAL_ORG_ID only — see the summary card in the editor column.
      summary: "",
      redirectProgrammeUrl: "",
      additionalTags: []
    }
  );
  const [formErrors, setFormErrors] = useState({
    blog_Title: "",
    blog_Type: "",
    blog_Description: "",
    SmallImage: "",
    thumbnail: "",
    blog_Body: "",
    selectedTag: "",
    categories: "",
    metaTitle: ""
  });

  useEffect(() => {
    dispatch(fetchUserForBlogs())
  }, [])

  const cookieLoginData = Cookies.get("loginData");

  useEffect(() => {
    if (cookieLoginData) {
      const parsedLoginData = JSON.parse(cookieLoginData);
      setOrgId(parsedLoginData?.organizationId ?? null);
    }
  }, [cookieLoginData]);

  const categoriesOption = [
    { value: "Admissions Advice", label: "Admissions Advice" },
    { value: "CXO Insight", label: "CXO Insight" },
    { value: "Unique Courses", label: "Unique Courses" },
    { value: "Placement Success", label: "Placement Success" },
    { value: "Outclass", label: "Outclass" },
    { value: "Startup Stories", label: "Startup Stories" },
    { value: "Mentor Spolight", label: "Mentor Spolight" },
    { value: "Research Papers", label: "Research Papers" },
    { value: "MBA Insight", label: "MBA Insight" },
    { value: "AI Careers", label: "AI Careers" },
    { value: "Events", label: "Events" }
  ]

  const onChangeFormData = (data) => {
    if (data && data.target && data.target.name) {
      const { name, value } = data.target;
      if (name == "isArticle" && value == "false") {
        setFormData({
          ...formData,
          articleLink: null,
          isArticle: false
        });
      } else if (name == "membersOnly" && value == "false") {
        setFormData({
          ...formData,
          membersOnly: false,
        });
      }
      else {
        setFormData({
          ...formData,
          [name]: value,
        });
      }

      setFormErrors({
        ...formErrors,
        [name]: "",
      });
    }
  };
  const onChangeFormTagData = (newTags) => {
    setFormData({
      ...formData,
      selectedTag: newTags,
    });
    setFormErrors({
      ...formErrors,
      selectedTag: "",
    });
  };

  const handleSummaryChange = (content) => {
    setFormData((prev) => ({
      ...prev,
      summary: content,
    }));
  };

  const onChangeAdditionalTags = (newTags) => {
    setFormData((prev) => ({
      ...prev,
      additionalTags: newTags,
    }));
  };

  const onChangeFormCategortyData = (obj, field) => {
    console.log(obj, "objjj");
    console.log(field, "field");
    const data = obj.map((ele) => ele.value)
    const { label, value } = obj;
    setFormData((prev) => ({
      ...prev,
      categories: data
    }));
    setFormErrors({
      ...formErrors,
      categories: "",
    });
  };

  const onChangeFormAuthorData = (obj, field) => {
    console.log(obj, "objjj");
    console.log(field, "field");
    const { label, value } = obj;
    setFormData((prev) => ({
      ...prev,
      author: obj?.value
    }));
    setFormErrors({
      ...formErrors,
      categories: "",
    });
  };

  const onChangeFaqs = (nextFaqs) => {
    setFormData((prev) => ({
      ...prev,
      faqs: nextFaqs,
    }));
  };

  const successToast = () => {
    toast.success(blogSliceSuccessMessage, {
      autoClose: 3000,
      hideProgressBar: false,
      pauseOnHover: true,
    });
  };

  const errorToast = () => {
    toast.error(blogSliceErrorMessage, {
      autoClose: 3000,
      hideProgressBar: false,
      pauseOnHover: true,
    });
  };

  const onClickUpload = async (event, name) => {
    if (event.target.files.length > 0) {
      console.log("in onClickUpload");
      const files = event.target.files;
      const fileFor = event.target.fileFor;
      setUploadingField(name);
      setFormErrors({
        ...formErrors,
        [name]: "",
      });
      await uploadFile(files, fileFor);
    }
  };
  const handleClick = (ref) => {
    if (ref.current) ref.current.click();
  };

  const handleSaveAsDraftToggle = () => {
    dispatch(dispatchSaveAsDraftButton(false));
  };

  const openSaveDraftPopup = () => {
    dispatch(dispatchSaveAsDraftButton(true));
  };

  const handleTemplateBodyChange = (content, words) => {
    console.log("con", content);
    const calculatedReadingTime = Math.ceil(words / 200);
    const readingTime = calculatedReadingTime < 1 ? 1 : calculatedReadingTime;
    setFormData((prevData) => ({
      ...prevData,
      blog_Body: content,
      wordCount: words,
      readingTime: readingTime,
      wordCount: words,
      readingTime: readingTime,
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      blog_Body: "",
    }));
  };

  useEffect(() => {
    if (fileUploadSuccess && !isFileUploading) {
      switch (uploadingField) {
        case "SmallImage":
          setFormData({
            ...formData,
            [uploadingField]: uploadedFileData[0].url,
          });
          setSmallImageName(uploadedFileData[0].name);
          break;

        case "thumbnail":
          setFormData({
            ...formData,
            [uploadingField]: uploadedFileData[0].url,
          });
          setThumbnailName(uploadedFileData[0].name);
          break;

        case "authorImage":
          setFormData({
            ...formData,
            [uploadingField]: uploadedFileData[0].url,
          });
          setAuthorImage(uploadedFileData[0].name);
          break;
      }
    }
  }, [isFileUploading]);

  useEffect(() => {
    if (location.state && location.state.draftData) {
      console.log("draftdt", location.state.draftData)
      const smallImageName = location.state.draftData?.smallImage.split('/').pop();
      const fileName = smallImageName?.split('_').pop();

      const thumbnailName = location.state.draftData?.thumbNail?.split('/').pop();
      const thumbnailFileName = thumbnailName?.split('_').pop();
      setFormData({
        blog_Title: location.state.draftData?.blog_Title,
        blog_Type: location.state.draftData?.blog_Type,
        blog_Description: location.state.draftData?.blog_description,
        SmallImage: location.state.draftData?.smallImage,
        thumbnail: location.state.draftData?.thumbNail,
        blog_Body: location.state.draftData?.blog_Body,
        wordCount: location.state.draftData?.blog_wordCount,
        readingTime: location.state.draftData?.blog_readingTime,
        selectedTag: location.state.draftData?.tags,
        blogId: location.state.draftData?._id,
        articleLink: location.state.draftData?.articleLink,
        isArticle: location.state.draftData?.isArticle,
        membersOnly: location.state.draftData?.membersOnly,
        youtubeUrl: location.state.draftData?.youtubeUrl,
        categories: location.state.draftData?.categories,
        authorName: location.state.draftData?.authorName,
        authorImage: location.state.draftData?.authorImage,
        faqs:
          Array.isArray(location.state.draftData?.FAQData)
            ? location.state.draftData.FAQData
            : Array.isArray(location.state.draftData?.faqs)
              ? location.state.draftData.faqs
              : [],
        summary: location.state.draftData?.summary ?? "",
        redirectProgrammeUrl: location.state.draftData?.redirectProgrammeUrl ?? "",
        // TagsInput requires an array — a draft saved before this field existed
        // returns undefined and would otherwise crash the input.
        additionalTags: Array.isArray(location.state.draftData?.additionalTags)
          ? location.state.draftData.additionalTags
          : [],
      })
      setSmallImageName(fileName);
      setThumbnailName(thumbnailFileName)
    }
  }, [location.state, orgId]);

  const handleSubmit = () => {
    let errors = {
      blog_Title: "",
      blog_Type: "",
      blog_Description: "",
      SmallImage: "",
      thumbnail: "",
      blog_Body: "",
      selectedTag: "",
      categories: "",
      metaTitle: ""
    };

    if (!formData.blog_Title) {
      errors.blog_Title = "Please enter blog title";
    }
    if (!formData.blog_Type) {
      errors.blog_Type = "Please select blog type";
    }
    if (!formData.blog_Description) {
      errors.blog_Description = "Please enter blog description";
    }
    if (!formData.SmallImage) {
      errors.SmallImage = "Please upload small image";
    }
    if (!formData.thumbnail) {
      errors.thumbnail = "Please upload thumbnail";
    }

    if (!formData.blog_Body) {
      errors.blog_Body = "Please enter Blog body";
    }
    if (!formData.selectedTag) {
      errors.selectedTag = 'Please enter Tag'
    }
    const isCategoriesEmpty = Array.isArray(formData.categories)
      ? formData.categories.length === 0
      : !formData.categories;
    if (isCategoriesEmpty) {
      errors.categories = 'Please select category'
    }
    if (!formData.metaTitle) {
      errors.metaTitle = "Please enter meta title";
    }

    let newObj = {
      blog_Title: formData.blog_Title,
      blog_Type: formData.blog_Type,
      blog_Description: formData.blog_Description,
      SmallImage: formData.SmallImage,
      thumbnail: formData.thumbnail,
      blog_Body: formData.blog_Body,
      wordCount: formData.wordCount,
      readingTime: formData.readingTime,
      selectedTag: formData.selectedTag,
      Draft: false,
      blogId: formData.blogId ? formData.blogId : "",
      youtubeUrl: formData?.youtubeUrl,
      articleLink: formData?.articleLink,
      isArticle: formData?.isArticle,
      membersOnly: formData?.membersOnly,
      categories: formData?.categories,
      author: formData?.author,
      altImg: formData?.altImg,
      metaTitle: formData?.metaTitle,
      FAQData: formData?.faqs || [],
    };
    if (orgId == SPECIAL_ORG_ID) {
      newObj.isLive = 0
    } else {
      newObj.summary = formData?.summary;
      newObj.redirectProgrammeUrl = formData?.redirectProgrammeUrl;
      newObj.additionalTags = formData?.additionalTags || [];
    }
    console.log(newObj);
    for (let key in errors) {
      if (errors[key]) {
        setFormErrors(errors);
        return;
      }
    }
    console.log("Blog added!", newObj);
    dispatch(createBlog(newObj));
  };

  useEffect(() => {
    console.log("form", formData)
  }, [formData])

  const handleRemoveImage = (uploadingField) => {
    switch (uploadingField) {
      case "SmallImage":
        setFormData({
          ...formData,
          [uploadingField]: "",
        });
        setSmallImageName("");
        break;

      case "thumbnail":
        setFormData({
          ...formData,
          [uploadingField]: "",
        });
        setThumbnailName("");
        break;

      case "authorImage":
        setFormData({
          ...formData,
          [uploadingField]: "",
        });
        setAuthorImage("");
        break;
    }
  };

  useEffect(() => {
    if (isBlogCreateSuccess && orgId != SPECIAL_ORG_ID) {
      successToast();
      setTimeout(function () {
        navigate("/", { replace: true });
      }, 1000);
    }
    if (isBlogCreateSuccess && orgId == SPECIAL_ORG_ID) {
      successToast();
      setTimeout(function () {
        navigate("/staging-blog", { replace: true });
      }, 1000);
    }
  }, [isBlogCreateSuccess]);

  useEffect(() => {
    if (isBlogSliceError) {
      errorToast();
    }
  }, [isBlogSliceError]);

  useEffect(() => {
    if (isBlogDraftCreateSuccess) {
      handleSaveAsDraftToggle();
      successToast();
      setTimeout(function () {
        navigate("/draft", { replace: true });
      }, 1000)
    }
  }, [isBlogDraftCreateSuccess])

  useEffect(() => {
    return () => {
      dispatch(clearBlogSliceStates());
      dispatch(clearBlogSliceMessages());
    };
  }, []);

  const handleSaveDraft = () => {
    console.log("formData.blog_Title:", formData);
    let newObj = {
      blog_Title: formData.blog_Title || 'No Title',
      blog_Type: formData.blog_Type,
      blog_Description: formData.blog_Description || 'No Description',
      SmallImage: formData.SmallImage,
      thumbnail: formData.thumbnail,
      blog_Body: formData.blog_Body,
      wordCount: formData.wordCount,
      readingTime: formData.readingTime,
      selectedTag: formData.selectedTag,
      articleLink: formData.articleLink,
      isArticle: formData.isArticle,
      membersOnly: formData.membersOnly,
      youtubeUrl: formData.youtubeUrl,
      categories: formData.categories,
      authorName: formData.authorName,
      authorImage: formData.authorImage,
      FAQData: formData.faqs || [],
      Draft: true
    };
    if (orgId != SPECIAL_ORG_ID) {
      newObj.summary = formData?.summary;
      newObj.redirectProgrammeUrl = formData?.redirectProgrammeUrl;
      newObj.additionalTags = formData?.additionalTags || [];
    }
    console.log(newObj);
    console.log("Draft added!", newObj);
    dispatch(createBlogAsDraft(newObj));
  };

  const isEditing = Boolean(formData?.blogId);
  const draftStatus = isEditing ? "Draft" : "New";

  return (
    <>
      <ToastContainer />
      {toggleSaveAsDraftPopup &&
        <LogoutPopup
          showActive={toggleSaveAsDraftPopup}
          message={"Are you sure you want to save this blog as draft?"}
          onCancel={handleSaveAsDraftToggle}
          onAllow={handleSaveDraft}
          isPopupFetching={isBlogSliceFetchingSmall}
        />}

      <CreateBlogMenu
        handleSaveDraft={openSaveDraftPopup}
        handlePreview={null}
        handleSubmit={handleSubmit}
        isBlogSliceFetchingSmall={isBlogSliceFetchingSmall || isFileUploading}
        isEditing={isEditing}
        draftStatus={draftStatus}
      />

      <div className={`wrapperBox singleMenu ${shouldShowErrorBorders ? "errorBorderEnabled" : ""}`}>
        <div className="cbPage">
          <div className="cbLayout">

            {/* ============ MAIN CONTENT COLUMN ============ */}
            <div className="cbMainCol">

              {/* Basics card */}
              <section className="cbCard">
                <div className="cbCardHeader">
                  <div className="cbCardTitle">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Blog Basics
                  </div>
                  <span className="cbCardHint">Title, type, and description</span>
                </div>
                <div className="cbCardBody">
                  <InputField
                    name="blog_Title"
                    className={`${shouldShowErrorBorders && formErrors.blog_Title ? "errorFieldBorder" : ""}`}
                    labelName={"Blog Title"}
                    placeholder={"Enter Blog Title"}
                    onChange={onChangeFormData}
                    isError={formErrors.blog_Title ? true : false}
                    erroMessage={formErrors.blog_Title}
                    value={formData?.blog_Title}
                  />
                  <InputField
                    name="blog_Type"
                    className={`${shouldShowErrorBorders && formErrors.blog_Type ? "errorFieldBorder" : ""}`}
                    labelName={"Blog Type"}
                    placeholder={"Enter Blog Type"}
                    onChange={onChangeFormData}
                    isError={formErrors.blog_Type ? true : false}
                    erroMessage={formErrors.blog_Type}
                    value={formData.blog_Type}
                  />
                  <InputField
                    name="blog_Description"
                    className={`${shouldShowErrorBorders && formErrors.blog_Description ? "errorFieldBorder" : ""}`}
                    labelName={"Blog Description"}
                    placeholder={"Enter Blog Description"}
                    onChange={onChangeFormData}
                    isError={formErrors.blog_Description ? true : false}
                    erroMessage={formErrors.blog_Description}
                    value={formData.blog_Description}
                  />
                </div>
              </section>

              {/* Featured media */}
              <section className="cbCard">
                <div className="cbCardHeader">
                  <div className="cbCardTitle">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
                      <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
                      <path d="M21 15l-5-5L5 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Featured Media
                  </div>
                  <span className="cbCardHint">Required cover and thumbnail</span>
                </div>
                <div className="cbCardBody">
                  <div className="uploadField">
                    {formData.SmallImage !== null && formData.SmallImage !== "" && (
                      <div className="imgPreview">
                        {formData.SmallImage !== "" && <img src={formData.SmallImage} alt="SmallImage" />}
                      </div>
                    )}
                    <div className="customField">
                      <CustomUploadBox
                        spacing={"formFileUploads"}
                        isimp={true}
                        label={"Small Image"}
                        onClickChooseFile={() => handleClick(SmallImageRef)}
                        onChange={(e) => onClickUpload(e, "SmallImage")}
                        isUploading={isFileUploading && uploadingField == "SmallImage"}
                        fileName={SmallImageName}
                        fileFor={"SmallImage"}
                        className={shouldShowErrorBorders && formErrors.SmallImage ? "errorUploadBorder" : ""}
                        isError={formErrors.SmallImage ? true : false}
                        erroMessage={formErrors.SmallImage}
                        fileUrl={formData?.SmallImage || formData?.SmallImage}
                        onRemoveImage={handleRemoveImage}
                        acceptedFileTypes={".jpg ,.jpeg,.png"}
                      />
                    </div>
                  </div>

                  <div className="uploadField">
                    {formData.thumbnail !== null && formData.thumbnail !== "" && (
                      <div className="imgPreview">
                        {formData.thumbnail !== "" && <img src={formData.thumbnail} alt="thumbnail" />}
                      </div>
                    )}
                    <div className="customField">
                      <CustomUploadBox
                        spacing={"formFileUploads"}
                        isimp={true}
                        label={"Thumbnail Image"}
                        onClickChooseFile={() => handleClick(ThumbnailRef)}
                        onChange={(e) => onClickUpload(e, "thumbnail")}
                        isUploading={isFileUploading && uploadingField == "thumbnail"}
                        fileName={thumbnailName}
                        fileFor={"thumbnail"}
                        className={shouldShowErrorBorders && formErrors.thumbnail ? "errorUploadBorder" : ""}
                        isError={formErrors.thumbnail ? true : false}
                        erroMessage={formErrors.thumbnail}
                        fileUrl={formData?.thumbnail || formData?.thumbnail}
                        onRemoveImage={handleRemoveImage}
                        acceptedFileTypes={".jpg ,.jpeg,.png"}
                      />
                    </div>
                  </div>
                </div>
              </section>

              {/* Body editor */}
              <section className="cbCard">
                <div className="cbCardHeader">
                  <div className="cbCardTitle">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M4 6h16M4 12h16M4 18h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    Article Body
                  </div>
                  <span className="cbCardHint">Write your content</span>
                </div>
                <div className="cbCardBody">
                  <div className={`${shouldShowErrorBorders && formErrors.blog_Body ? "tinyEditorError" : ""}`}>
                    <TinyEditor
                      onChange={handleTemplateBodyChange}
                      initialValue={formData?.blog_Body}
                    />
                  </div>
                  {formErrors.blog_Body && (
                    <div className="formGroups blogBodyError">
                      <span className="FormError">{formErrors.blog_Body}</span>
                    </div>
                  )}
                  <div className="cbEditorMeta">
                    <span>Words: <strong>{formData?.wordCount || 0}</strong></span>
                    <span>Reading time: <strong>{formData?.readingTime || 0} min</strong></span>
                  </div>
                </div>
              </section>

              {/* FAQ */}
              <section className="cbCard">
                <div className="cbCardHeader">
                  <div className="cbCardTitle">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    FAQs
                  </div>
                  <span className="cbCardHint">Optional Q&amp;A schema</span>
                </div>
                <div className="cbCardBody">
                  <FaqSection
                    label={"FAQs"}
                    value={formData?.faqs}
                    onChange={onChangeFaqs}
                    remountKey={String(formData.blogId || "create-new")}
                  />
                </div>
              </section>

              {/* Summary block — rendered for every org except SPECIAL_ORG_ID */}
              {orgId != SPECIAL_ORG_ID && (
                <section className="cbCard">
                  <div className="cbCardHeader">
                    <div className="cbCardTitle">
                      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M4 6h16M4 12h16M4 18h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                      Summary
                    </div>
                    <span className="cbCardHint">Optional summary, programme CTA, and extra tags</span>
                  </div>
                  <div className="cbCardBody">
                    <div className="formGroups">
                      <label>Summary</label>
                      {/* Rich text so the summary can carry a key-takeaways list.
                          TinyEditor is uncontrolled — the key remounts it when a
                          draft loads, matching how FaqSection does it. */}
                      <TinyEditor
                        key={`summary-${formData.blogId || "create-new"}`}
                        initialValue={formData?.summary || ""}
                        onChange={handleSummaryChange}
                        height={300}
                      />
                    </div>

                    <InputField
                      name="redirectProgrammeUrl"
                      labelName={"Redirect Programme Page URL"}
                      notImp={true}
                      placeholder={"Enter programme page link"}
                      onChange={onChangeFormData}
                      value={formData?.redirectProgrammeUrl}
                    />

                    <div className="formGroups">
                      <label>Additional Tags</label>
                      <TagsInput
                        name="additionalTags"
                        placeHolder="Enter tags and press Enter"
                        onChange={onChangeAdditionalTags}
                        value={formData?.additionalTags}
                      />
                    </div>
                  </div>
                </section>
              )}
            </div>

            {/* ============ META SIDEBAR COLUMN ============ */}
            <aside className="cbSideCol">

              {/* Categorisation */}
              <section className="cbCard">
                <div className="cbCardHeader">
                  <div className="cbCardTitle">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                      <circle cx="7" cy="7" r="1.5" fill="currentColor"/>
                    </svg>
                    Categorisation
                  </div>
                </div>
                <div className="cbCardBody">
                  <div className="formGroups">
                    <label>Tags</label>
                    <TagsInput
                      name="tags"
                      placeHolder="Enter tags and press Enter"
                      onChange={onChangeFormTagData}
                      isError={formErrors.selectedTag ? true : false}
                      erroMessage={formErrors.selectedTag}
                      value={formData.selectedTag}
                    />
                  </div>

                  {orgId == SPECIAL_ORG_ID ? (
                    <InputField
                      name="categories"
                      className={`${shouldShowErrorBorders && formErrors.categories ? "errorFieldBorder" : ""}`}
                      labelName={"Add Category (Max 50 characters)"}
                      placeholder={"Enter Blog Category"}
                      onChange={onChangeFormData}
                      checkBoxWrap={"pd"}
                      isError={formErrors.categories ? true : false}
                      erroMessage={formErrors.categories}
                      value={formData?.categories}
                      max={60}
                    />
                  ) : (
                    <CustomSearchableDropdown
                      options={categoriesOption}
                      isimp={true}
                      isMulti={true}
                      className="dropUpMenu w100 zIndex"
                      label={"Select Categories"}
                      field="categories"
                      erroMessage={formErrors.categories}
                      onChange={onChangeFormCategortyData}
                    />
                  )}
                </div>
              </section>

              {/* Author + Article options */}
              <section className="cbCard">
                <div className="cbCardHeader">
                  <div className="cbCardTitle">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                    Author & Options
                  </div>
                </div>
                <div className="cbCardBody">
                  <InputField
                    name="youtubeUrl"
                    labelName={"Youtube Link"}
                    notImp={true}
                    placeholder={"Enter link"}
                    onChange={onChangeFormData}
                    value={formData.youtubeUrl}
                  />

                  <div className="formGroups cbInlineLabel">
                    <label>Is this an article?</label>
                    <div className="cbInlineRadios">
                      <CustomRadioButton
                        name={'isArticle'}
                        text={'Yes'}
                        label={'Yes'}
                        value={true}
                        className={"radioButton"}
                        checked={formData?.isArticle === "true"}
                        onChange={onChangeFormData}
                      />
                      <CustomRadioButton
                        name={'isArticle'}
                        text={'No'}
                        label={'No'}
                        value={false}
                        className={"radioButton"}
                        checked={formData?.isArticle === "false"}
                        onChange={onChangeFormData}
                      />
                    </div>
                  </div>

                  {formData?.isArticle === "true" && (
                    <InputField
                      name="articleLink"
                      labelName={"Article Link"}
                      notImp={true}
                      placeholder={"Enter link"}
                      onChange={onChangeFormData}
                      value={formData.articleLink}
                    />
                  )}

                  {orgId != SPECIAL_ORG_ID && (
                    <div className="formGroups cbInlineLabel">
                      <label>Members only?</label>
                      <div className="cbInlineRadios">
                        <CustomRadioButton
                          name={'membersOnly'}
                          text={'Yes'}
                          label={'Yes'}
                          value={true}
                          className={"radioButton"}
                          checked={formData?.membersOnly === "true"}
                          onChange={onChangeFormData}
                        />
                        <CustomRadioButton
                          name={'membersOnly'}
                          text={'No'}
                          label={'No'}
                          value={false}
                          className={"radioButton"}
                          checked={formData?.membersOnly === "false"}
                          onChange={onChangeFormData}
                        />
                      </div>
                    </div>
                  )}

                  {orgId == SPECIAL_ORG_ID && (
                    <>
                      <InputField
                        name="authorName"
                        className={`${shouldShowErrorBorders && formErrors.authorName ? "errorFieldBorder" : ""}`}
                        labelName={"Add Author"}
                        placeholder={"Enter Blog Author"}
                        onChange={onChangeFormData}
                        value={formData?.authorName}
                      />
                      <div className="uploadField">
                        {formData.authorImage !== null && formData.authorImage !== "" && (
                          <div className="imgPreview">
                            {formData.authorImage !== "" && <img src={formData.authorImage} alt="authorImage" />}
                          </div>
                        )}
                        <div className="customField">
                          <CustomUploadBox
                            spacing={"formFileUploads"}
                            isimp={false}
                            label={"Author Image"}
                            onClickChooseFile={() => handleClick(authorImageRef)}
                            onChange={(e) => onClickUpload(e, "authorImage")}
                            isUploading={isFileUploading && uploadingField == "authorImage"}
                            fileName={authorImage}
                            fileFor={"authorImage"}
                            isError={formErrors.authorImage ? true : false}
                            erroMessage={formErrors.authorImage}
                            fileUrl={formData?.authorImage || formData?.authorImage}
                            onRemoveImage={handleRemoveImage}
                            acceptedFileTypes={".jpg ,.jpeg,.png"}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </section>

              {/* SEO accordion */}
              <section className="cbCard cbAccordion" data-open={seoOpen ? "true" : "false"}>
                <div
                  className="cbCardHeader"
                  onClick={() => setSeoOpen(!seoOpen)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setSeoOpen(!seoOpen);
                    }
                  }}
                >
                  <div className="cbCardTitle">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/>
                      <line x1="21" y1="21" x2="16.65" y2="16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    SEO
                  </div>
                  <svg className="cbCardChevron" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="cbCardBody">
                  <InputField
                    name="altImg"
                    labelName={"Alt tag for image"}
                    placeholder={"Enter alt text"}
                    onChange={onChangeFormData}
                    notImp={true}
                    value={formData?.altImg}
                  />
                  <InputField
                    name="metaTitle"
                    className={`${shouldShowErrorBorders && formErrors.metaTitle ? "errorFieldBorder" : ""}`}
                    labelName={"Meta Title"}
                    placeholder={"Enter Meta Title"}
                    onChange={onChangeFormData}
                    notImp={false}
                    isError={formErrors.metaTitle ? true : false}
                    erroMessage={formErrors.metaTitle}
                    value={formData?.metaTitle}
                  />
                </div>
              </section>

              {/* Publish action card */}
              <section className="cbCard">
                <div className="cbCardBody">
                  <Button
                    className={"BlueFillButton iconButton w100"}
                    name={isEditing ? "Update Blog" : "Publish Blog"}
                    onClick={handleSubmit}
                    isWaiting={isBlogSliceFetchingSmall || isFileUploading}
                    disabled={isBlogSliceFetchingSmall || isFileUploading}
                  />
                </div>
              </section>
            </aside>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateBlog;
